<template>
  <div>
    <div v-if="canInitVideoIdentication">
      <camera
        @initRecorder="checkConditionsToStartIdentificationProcess"
        v-if="
          !this.isIOS &&
            !this.isIPad &&
            !this.isSafari &&
            !this.isIE11 &&
            !this.isEdge
        "
      ></camera>
      <opentok
        @initRecorder="checkConditionsToStartIdentificationProcess"
        :end-point="endPoint"
        :token="token"
        :operation-uuid="operationUuid"
        v-if="
          this.isIOS ||
            this.isIPad ||
            this.isSafari ||
            this.isIE11 ||
            this.isEdge
        "
      ></opentok>
      <canvas
        id="canvas"
        :width="cvWidth"
        :height="cvHeight"
        class="centerHorizontalAbsolute"
      ></canvas>
      <canvas
        id="canvasGuide"
        :width="vWidth"
        :height="vHeight"
        class="centerHorizontalAbsolute"
      ></canvas>
      <canvas
        id="canvasMessages"
        :width="vWidth"
        :height="vHeight"
        class="centerHorizontalAbsolute"
      ></canvas>
      <canvas
        id="canvasRectangle"
        :width="vWidth"
        :height="vHeight"
        class="centerHorizontalAbsolute"
      ></canvas>
      <canvas
        id="canvasCheckMark"
        width="120"
        height="70"
        class="centerHorizontalAbsolute"
        :class="{
          canvasCheckMarkMobileLandscape: !isPortrait && !isDesktop,
          canvasCheckMarkMobilePortrait: isPortrait && !isDesktop
        }"
      ></canvas>
      <canvas
        id="canvasRecordCircle"
        width="30"
        height="30"
        class="centerHorizontalAbsolute"
        :class="{
          canvasRecordCircleMobileLandscape: !isPortrait && !isDesktop,
          canvasRecordCircleMobilePortrait: isPortrait && !isDesktop
        }"
      ></canvas>
      <canvas
        id="canvasLiveness"
        :width="vWidth"
        :height="vHeight"
        class="centerHorizontalAbsolute"
      ></canvas>
      <canvas
        id="canvasVideo"
        :width="vWidth"
        :height="vHeight"
        class="centerHorizontalAbsolute"
      ></canvas>
      <canvas
        id="images"
        class="pointCanvas centerHorizontalAbsolute"
        width="640"
        height="480"
      ></canvas>
    </div>
    <div v-if="!canInitVideoIdentication">
      <p class="esign-error-text" v-if="tokenMsg">
        El token es obligatorio para poder realizar la identificación.
      </p>
      <p class="esign-error-text" v-if="endPointMsg">
        El end point es un campo obligatorio para poder realizar la
        identificación.
      </p>
      <p class="esign-error-text" v-if="endPointVideoMsg">
        El end point del servicio de identificación es un campo obligatorio para
        poder realizar la identificación.
      </p>
      <p class="esign-error-text" v-if="domainUuidMsg">
        El identificador del dominio es un campo obligatorio para poder realizar
        la identificación.
      </p>
      <p class="esign-error-text" v-if="operationUuidMsg">
        El identificador de la operación es un campo obligatorio para poder
        realizar la identificación.
      </p>
    </div>
    <p id="snackbar-success"></p>
    <p id="snackbar-info"></p>
    <p id="snackbar-error"></p>
  </div>
</template>

<script>
// https://www.npmjs.com/package/recordrtc
import Camera from "./Camera";
import Opentok from "./Session";
// import live from './Liveness';
import concatenatedBlobs from "./ConcatenateBlobs";

let rtc = require("recordrtc");

export default {
  components: { Camera, Opentok },
  props: {
    token: { type: String, required: true },
    endPoint: { type: String, required: true },
    endPointVideo: { type: String, required: true },
    operationUuid: { type: String, required: true },
    domainUuid: { type: String, required: true },
    showRecorderIndicator: { type: Boolean, default: false },
    detectBrightnessInVideo: { type: Boolean, default: true },
    brightnessVideoThreshold: {
      type: Array,
      default: function() {
        return [20, 80];
      }
    },
    detectBrightnessInImage: { type: Boolean, default: true },
    brightnessImageThreshold: { type: Number, default: 300 },
    detectBlurInImage: { type: Boolean, default: true },
    blurImageThreshold: { type: Number, default: 100 },
    doLivenessDetection: { type: Boolean, default: false },
    doFaceDetection: { type: Boolean, default: true },
    doHologramDetection: { type: Boolean, default: true },
    doFrontDetection: { type: Boolean, default: true },
    doBackDetection: { type: Boolean, default: true },
    frontConfidence: { type: Number, default: 0.75 },
    hologramConfidence: { type: Number, default: 0.75 },
    backConfidence: { type: Number, default: 0.75 },
    biometry: { type: Boolean, default: true },
    biometryConfidence: { type: Number, default: 0.3 },
    biometryBlocking: { type: Boolean, default: false },
    withFaceRect: { type: Number, default: 150 },
    returnFaceImage: { type: Boolean, default: true },
    returnFrontImage: { type: Boolean, default: true },
    returnHologramImage: { type: Boolean, default: true },
    returnBackImage: { type: Boolean, default: true },
    returnFrontOcr: { type: Boolean, default: false },
    returnBackOcr: { type: Boolean, default: true },
    returnPassportImage: { type: Boolean, default: true },
    returnPassportMrzImage: { type: Boolean, default: true },
    returnPassportMrzOcr: { type: Boolean, default: true },
    videoTimeout: { type: Number, default: 10 },
    status: { type: Number, default: 0 },
    response: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    snackBar: { type: Boolean, default: false },
    identificationMessages: {
      type: Object,
      default: function() {
        return {
          initIdentification: "Iniciando identificación",
          cannotInitIdentification: "No se ha podido iniciar la identificación",
          minimumBrightness:
            "La luz es insuficiente para iniciar la identificación",
          optimumBrightness: "La luz es óptima para realizar la identificación",
          maximumBrightness:
            "La luz es muy alta para realizar la identificación",
          brightnessImage:
            "Reflejos o brillos detectados, cambie las condiciones de luz",
          blurFaceImage:
            "Procure no moverse mientras su cara está siendo detectada",
          blurDocumentImage:
            "Procure no mover su documento mientras está siendo detectado",
          livenessDetection: "Gire la cabeza hacía la bola amarilla",
          livenessDetectionFinish: "Prueba de vida completada",
          faceDetection: "Detección de la cara",
          faceDetectionClose: "Acerque su cara",
          faceDetectionFinish: "Su cara ha sido detectada",
          passportDetection: "Muestre su pasaporte",
          passportDetectionFinish: "Su pasaporte ha sido detectado",
          biometryBlocking: "No ha pasado el reconocimiento biométrico",
          frontDetection: "Muestre el frontal de su documento",
          frontDetectionAdjust: "Acerque el frontal del documento",
          frontDetectionFinish: "El frontal de su documento ha sido detectado",
          backDetection: "Muestre el reverso del documento",
          backDetectionAdjust: "Acerque el reverso del documento",
          backDetectionFinish: "El reverso de su documento ha sido detectado",
          identificationFinish: "La identificación se ha completado"
        };
      }
    },
    snackBarMessages: {
      type: Object,
      default: () => {
        return {
          initRecordError: "Ha ocurrido un error al iniciar la grabación",
          startRecord: "Ha comenzado la grabación",
          timeoutIdentification:
            "Se ha terminado el tiempo para realizar la identificación",
          successFaceMsg: "La cara ha sido detectada",
          errorFaceMsg: "Ha ocurrido un error al detectar la cara",
          successDocumentTypeMsg: "El tipo de documento ha sido detectado",
          errorDocumentTypeMsg:
            "Ha ocurrido un error al detectar el tipo de documento",
          successFrontMsg: "El frontal del documento ha sido detectado",
          errorFrontMsg:
            "Ha ocurrido un error al detectar el frontal del documento",
          successBackMsg: "El reverso del documento ha sido detectado",
          errorBackMsg:
            "Ha ocurrido un error al detectar el reverso del documento",
          saveVideoSuccess:
            "El vídeo se ha guardado y la identificación se ha completado",
          saveVideoError: "Ha ocurrido un error al guardar el vídeo",
          endVideoIdentificationMsg: "La vídeo identificación se ha completado"
        };
      }
    }
  },
  data() {
    return {
      tokenMsg: false,
      endPointMsg: false,
      endPointVideoMsg: false,
      operationUuidMsg: false,
      domainUuidMsg: false,
      canInitVideoIdentication: false,
      endVideoTimeout: undefined,
      video: undefined,
      videoUuid: String,
      face: {},
      rectangle: {},
      documentType: {},
      front: {},
      hologram: {},
      back: {},
      dni: "",
      rejectOpMsg: "",
      canReject: true,
      isIdentificationEnded: false,
      isFaceDetection: true,
      isDocumentTypeDetection: false,
      isFrontDetection: false,
      isBackDetection: false,
      isDesktop: true,
      isHD: false,
      vWidth: 640,
      vHeight: 480,
      cvWidth: 640,
      cvHeight: 480,
      canvasRect: undefined,
      contextRect: undefined,
      contextGuide: undefined,
      contextMessages: undefined,
      contextCheckMark: undefined,
      canvasRecordCircle: undefined,
      contextRecordCircle: undefined,
      recorder: {},
      stream: {},
      startVideoTime: Number,
      endVideoTime: Number,
      firstBlob: undefined,
      blobsArray: [],
      videoDuration: Number,
      lastTimeRecordCircle: performance.now(),
      intervalRecordCircle: undefined,
      circles: {},
      INFO_NEUTRAL_COLOR: "rgba(137, 137, 137, 0.6)",
      INFO_NEUTRAL_BORDER_COLOR: "rgb(137, 137, 137)",
      INFO_SUCCESS_COLOR: "rgba(208, 255, 134, 0.6)",
      INFO_SUCCESS_BORDER_COLOR: "rgb(208, 255, 134)",
      INFO_ERROR_COLOR: "rgba(255, 106, 106, 0.6)",
      INFO_ERROR_BORDER_COLOR: "rgb(255, 106, 106)",
      INFO_WHITE_TEXT: "white",
      INFO_BLACK_TEXT: "black",
      INFO_HEIGHT: "",
      INFO_WIDTH: "",
      isIOS: undefined,
      isIPad: undefined,
      isMacintosh: undefined,
      isAndroid: undefined,
      isFirefox: undefined,
      isIOSChrome: undefined,
      isIE11: undefined,
      isEdge: undefined,
      isSafari: undefined,
      isOpera: undefined,
      isChrome: undefined,
      userAgentMobile: undefined,
      safariVersion: undefined,
      iOSVersion: undefined,
      isAndroidTablet: false,
      isPortrait: false,
      isPortraitTablet: false,
      publisher: undefined,
      isInit: false,
      faceTimeoutToFrontDetection: 2000,
      timeoutOrientation: undefined,
      videoTimeoutReached: false,
      blinkVideo: undefined,
      timeoutOrientation: undefined,
      connectionTestSuccess: false
    };
  },
  created() {
    this.tokenMsg =
      (typeof this.token === "undefined" || this.token === "") === true;
    this.endPointMsg =
      (typeof this.endPoint === "undefined" || this.endPoint === "") === true;
    this.endPointVideoMsg =
      (typeof this.endPointVideo === "undefined" ||
        this.endPointVideo === "") === true;
    this.operationUuidMsg =
      (typeof this.operationUuid === "undefined" ||
        this.operationUuid === "") === true;
    this.domainUuidMsg =
      (typeof this.domainUuid === "undefined" || this.domainUuid === "") ===
      true;
    if (
      this.tokenMsg === false &&
      this.endPointMsg === false &&
      this.endPointVideoMsg === false &&
      this.operationUuidMsg === false &&
      this.domainUuidMsg === false
    ) {
      this.canInitVideoIdentication = true;
    }
    this.isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.isIPad = /iPad/.test(navigator.userAgent) && !window.MSStream;
    this.isMacintosh =
      /Macintosh/.test(navigator.userAgent) && !window.MSStream;
    this.isAndroid = /Android/.test(navigator.userAgent) && !window.MSStream;
    this.isFirefox = /Firefox/.test(navigator.userAgent) && !window.MSStream;
    this.isIOSChrome =
      /Chrome&CriOS/.test(navigator.userAgent) && !window.MSStream;
    this.isIE11 = /Trident/.test(navigator.userAgent) && !window.MSStream;
    this.isEdge = /Edge/.test(navigator.userAgent);
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.isOpera = /Opera/.test(navigator.userAgent) && !window.MSStream;
    this.isChrome = /Chrome/.test(navigator.userAgent) && !window.MSStream;
    // TODO remover
    // this.isIOS = true;

    this.isDesktop = true;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.isDesktop = false;
    }
    // Android tablet
    if (this.isAndroid) {
      this.isAndroidTablet = true;
      if (navigator.userAgent.indexOf("Mobile") !== -1) {
        this.isAndroidTablet = false;
      }
    }
    // Get Safari Version
    let offset = navigator.userAgent.indexOf("Version");
    if (navigator.userAgent.indexOf("Version") !== -1) {
      let version = navigator.userAgent.substring(offset + 8);
      this.safariVersion = parseFloat(version.split(".")[0].trim());
    }
    // Get iOS Version
    let iOSoffset = navigator.userAgent.indexOf("iPhone OS");
    let iPadOffset = navigator.userAgent.indexOf("iPad");
    if (navigator.userAgent.indexOf("iPhone OS") !== -1) {
      let version1 = navigator.userAgent.substring(iOSoffset + 10);
      this.iOSVersion = version1.substring(0, 4).trim();
      if (this.iOSVersion.includes("_")) {
        this.iOSVersion = parseFloat(this.iOSVersion.split("_")[0].trim());
      }
    } else if (navigator.userAgent.indexOf("iPad") !== -1) {
      let version2 = navigator.userAgent.substring(iPadOffset + 13);
      this.iOSVersion = version2.substring(0, 4).trim();
      if (this.iOSVersion.includes("_")) {
        this.iOSVersion = parseFloat(this.iOSVersion.split("_")[0].trim());
      }
    }
    // Get width and heigth and if the orientation is portrait or landscape
    this.isPortrait = false;
    this.isPortraitTablet = false;
    if (window.innerHeight > window.innerWidth && !this.isDesktop) {
      this.isPortrait = true;
      this.isPortraitTablet = true;
    }

    if (this.isDesktop) {
      this.INFO_HEIGHT = 445;
      this.INFO_WIDTH = 542;
    } else if (this.isPortrait) {
      this.INFO_HEIGHT = 310;
      this.INFO_WIDTH = 220;
      this.vWidth = 240;
      this.vHeight = 320;
      this.cvWidth = 480;
      this.cvHeight = 640;
    } else {
      this.INFO_HEIGHT = 225;
      this.INFO_WIDTH = 300;
      this.vWidth = 320;
      this.vHeight = 240;
      this.cvWidth = 640;
      this.cvHeight = 480;
    }

    if (
      this.isIOS ||
      this.isIPad ||
      this.isSafari ||
      this.isIE11 ||
      this.isEdge
    ) {
      this.EventBus.$on("cannotInitIdentification", () => {
        this.canInitVideoIdentication();
      });
      this.EventBus.$on("videoUuid", value => {
        this.videoUuid = value;
        this.$store.commit("setVideoUuid", this.videoUuid);
      });
      this.EventBus.$on("setPublisher", value => {
        this.publisher = value;
      });
      this.EventBus.$on("initDetections", () => {
        // this.drawFaceCircleOverVideo();
        this.initDetections();
      });
      this.EventBus.$on("calculateVideoParams", () => {
        this.calculateVideoParams();
      });
    }
    if (!this.isIOS && !this.isIPad) {
      window.addEventListener("orientationchange", this.orientationChanged);
    } else {
      const $this = this;
      this.timeoutOrientation = setInterval(() => {
        $this.getOrientation();
      }, 200);
    }
  },
  beforeDestroy() {
    if (
      !this.isIOS &&
      !this.isIPad &&
      !this.isSafari &&
      !this.isIE11 &&
      !this.isEdge
    ) {
      this.closeCamera();
    } else {
      this.EventBus.$emit("sessionDisconnect");
      clearInterval(this.timeoutOrientation);
    }
  },
  destroyed() {
    if (
      !this.isIOS &&
      !this.isIPad &&
      !this.isSafari &&
      !this.isIE11 &&
      !this.isEdge
    ) {
      this.closeCamera();
    } else {
      this.EventBus.$emit("sessionDisconnect");
      clearInterval(this.timeoutOrientation);
    }
  },
  methods: {
    getOrientation() {
      if (window.innerHeight > window.innerWidth) {
        this.prueba = "portrait";
      } else {
        this.prueba = "landscape";
      }
      this.iosOrientation();
    },
    iosOrientation() {
      if (this.prueba === "portrait") {
        this.isPortrait = true;
        this.EventBus.$emit("portrait");
        this.INFO_HEIGHT = 310;
        this.INFO_WIDTH = 220;
        this.vWidth = 240;
        this.vHeight = 320;
        this.cvWidth = 480;
        this.cvHeight = 640;
      } else {
        this.isPortrait = false;
        this.EventBus.$emit("landscape");
        this.INFO_HEIGHT = 225;
        this.INFO_WIDTH = 300;
        this.vWidth = 320;
        this.vHeight = 240;
        this.cvWidth = 640;
        this.cvHeight = 480;
      }
      // if (this.isInit) {
      // this.drawGuideOverVideoOrientationChanged()
      // }
    },
    orientationChanged(event) {
      if (screen.orientation.angle === 90 || screen.orientation.angle === 270) {
        // landscape
        this.isPortrait = false;
        this.EventBus.$emit("landscape");
        this.INFO_HEIGHT = 225;
        this.INFO_WIDTH = 300;
        this.vWidth = 320;
        this.vHeight = 240;
        this.cvWidth = 640;
        this.cvHeight = 480;
      } else {
        this.isPortrait = true;
        this.EventBus.$emit("portrait");
        this.INFO_HEIGHT = 310;
        this.INFO_WIDTH = 220;
        this.vWidth = 240;
        this.vHeight = 320;
        this.cvWidth = 480;
        this.cvHeight = 640;
      }
      // this.drawGuideOverVideoOrientationChanged()
    },
    drawGuideOverVideoOrientationChanged() {
      setTimeout(() => {
        if (this.isFaceDetection) {
          this.drawFaceCircleOverVideo();
        } else {
          var ar = this.calculateAspectRatio(
            this.vWidth,
            this.vHeight,
            false,
            this.isDesktop
          );
          var co = this.calculateCanvasPosition(
            this.vWidth,
            this.vHeight,
            ar.arWidth,
            ar.arHeight
          );
          var canvasGuide = document.getElementById("canvasGuide");
          this.contextGuide = canvasGuide.getContext("2d");
          this.insertCanvasOverVideo(
            canvasGuide,
            this.contextGuide,
            this.vWidth,
            this.vHeight,
            ar.arWidth,
            ar.arHeight,
            co.x,
            co.y,
            "red"
          );
        }
      }, 750);
    },
    checkConditionsToStartIdentificationProcess(stream) {
      if (this.detectBrightnessInVideo) {
        setTimeout(() => {
          this.averageBrightnessDetection(stream);
        }, 3000);
      } else {
        this.initRecorder(stream);
      }
    },
    initRecorder(stream) {
      if (this.isFaceDetection) {
        this.EventBus.$emit("initIdentification", true);
      }
      if (!this.isDesktop && this.isInit) {
        this.recorder = new rtc.RecordRTCPromisesHandler(stream, {
          type: "video"
        });
        this.stream = stream;
        this.recorder.startRecording();
      }
      if (
        !this.isIOS &&
        !this.isIPad &&
        !this.isSafari &&
        !this.isIE11 &&
        !this.isEdge &&
        !this.isInit
      ) {
        if (this.showRecorderIndicator) {
          this.canvasRecordCircle = document.getElementById(
            "canvasRecordCircle"
          );
          this.contextRecordCircle = this.canvasRecordCircle.getContext("2d");
          this.circles.red = {
            x: 15,
            y: 15,
            radius: 8,
            color: "red",
            visibleDuration: 1500,
            visibleCountdown: 0
          };
          this.animate();
        }
        this.recorder = new rtc.RecordRTCPromisesHandler(stream, {
          type: "video"
        });
        this.stream = stream;
      }
      let timeoutMobile = 2500;
      if (
        this.isDesktop ||
        (!this.isIOS &&
          !this.isIPad &&
          !this.isSafari &&
          !this.isIE11 &&
          !this.isEdge)
      ) {
        timeoutMobile = 0;
      }
      setTimeout(() => {
        if (!this.isInit) {
          this.isInit = true;
          this.initIdentification();
        }
      }, timeoutMobile);
    },
    initIdentification() {
      if (
        !this.isIOS &&
        !this.isIPad &&
        !this.isSafari &&
        !this.isIE11 &&
        !this.isEdge
      ) {
        this.video = document.querySelector("#video");
        var interval = setInterval(() => {
          if (this.video.readyState === 4) {
            var canvasMessages = document.getElementById("canvasMessages");
            this.contextMessages = canvasMessages.getContext("2d");
            if (
              !this.isIOS ||
              !this.isIPad ||
              !this.isSafari ||
              !this.isIE11 ||
              !this.isEdge
            ) {
              setTimeout(() => {
                this.startArchive();
              }, 500);
            }
            this.cleanShowInfoDetectionMessages(
              this.contextMessages,
              this.vWidth,
              this.vHeight
            );
            this.showInfoDetectionMessages(
              this.contextMessages,
              this.identificationMessages.initIdentification,
              this.INFO_WIDTH,
              this.INFO_HEIGHT,
              this.INFO_SUCCESS_BORDER_COLOR,
              this.INFO_SUCCESS_COLOR,
              this.INFO_BLACK_TEXT
            );
            clearInterval(interval);
          }
        }, 500);
      } else {
        var canvasMessages = document.getElementById("canvasMessages");
        this.contextMessages = canvasMessages.getContext("2d");
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.identificationMessages.initIdentification,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_SUCCESS_BORDER_COLOR,
          this.INFO_SUCCESS_COLOR,
          this.INFO_BLACK_TEXT
        );
      }
    },
    startArchive() {
      this.$http.defaults.headers.common.Authorization = this.token;
      this.$http
        .post(`${this.endPoint}${"startidentification/"}${this.operationUuid}`)
        .then(
          responseSuccess => {
            console.log("Se ha cambiado el estado de la operación a grabando.");
            this.videoUuid = responseSuccess.data.videouuid;
            this.$store.commit("setVideoUuid", this.videoUuid);
            this.startVideoTime = new Date();
            this.recorder.startRecording();
            if (this.showRecorderIndicator) {
              setTimeout(() => {
                this.showRecordCircle(this.circles.red);
              }, 10);
              this.intervalRecordCircle = setInterval(() => {
                setTimeout(() => {
                  this.showRecordCircle(this.circles.red);
                }, 10);
              }, 1750);
            }
            if (this.snackBar) {
              this.$showSnackBar(
                "snackbar-info",
                this.snackBarMessages.startRecord
              );
            }
            // this.drawFaceCircleOverVideo();
            this.initDetections();
          },
          responseError => {
            console.log(
              "Ha ocurrido un error al cambiar el estado de la operación a grabando. ",
              responseError.response.status
            );
            this.cannotInitIdentification();
            this.EventBus.$emit("initIdentification", false); // Steppers
            if (this.snackBar) {
              this.$showSnackBar(
                "snackbar-error",
                this.snackBarMessages.initRecordError
              );
            }
            if (
              !this.isIOS &&
              !this.isIPad &&
              !this.isSafari &&
              !this.isIE11 &&
              !this.isEdge
            ) {
              this.closeCamera();
            } else {
              this.EventBus.$emit("sessionDisconnect");
            }
            this.$emit("notify", "hideLoading");
            this.$emit("error", "Can´t start recording");
          }
        );
    },
    cannotInitIdentification() {
      this.cleanShowInfoDetectionMessages(
        this.contextMessages,
        this.vWidth,
        this.vHeight
      );
      this.showInfoDetectionMessages(
        this.contextMessages,
        this.identificationMessages.cannotInitIdentification,
        this.INFO_WIDTH,
        this.INFO_HEIGHT,
        this.INFO_ERROR_BORDER_COLOR,
        this.INFO_ERROR_COLOR,
        this.INFO_WHITE_TEXT
      );
      this.canInitVideoIdentication = false;
      clearTimeout(this.endVideoTimeout);
      if (
        !this.isIOS &&
        !this.isIPad &&
        !this.isSafari &&
        !this.isIE11 &&
        !this.isEdge
      ) {
        this.closeCamera();
      } else {
        this.EventBus.$emit("sessionDisconnect");
      }
    },
    initDetections() {
      // this.EventBus.$emit('initIdentification', true);
      this.endVideoTimeout = setTimeout(() => {
        if (
          this.isIOS ||
          this.isIPad ||
          this.isSafari ||
          this.isIE11 ||
          this.isEdge
        ) {
          this.EventBus.$emit("stopRecording");
          this.logicPostStopOpenTok();
        } else {
          this.stopRecording();
        }
        this.videoTimeoutReached = true;
        this.cannotInitIdentification();
        this.EventBus.$emit("snackBarInfo", {
          snackBarText: this.snackBarMessages.timeoutIdentification,
          snackBarBtn: ""
        });
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.snackBarMessages.timeoutIdentification,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_ERROR_BORDER_COLOR,
          this.INFO_ERROR_COLOR,
          this.INFO_WHITE_TEXT
        );
      }, this.videoTimeout * 60000);
      this.startIdentificationProcess();
    },
    averageBrightnessDetection(stream) {
      // https://www.madebymike.com.au/writing/html5-video-streaming/
      if (!this.isInit) {
        if (
          this.isIOS ||
          this.isIPad ||
          this.isSafari ||
          this.isIE11 ||
          this.isEdge
        ) {
          var video = document.querySelector(".OT_video-element");
        } else {
          var video = document.querySelector("#video");
        }
        if (typeof video !== "undefined" && video !== null) {
          var canvas = document.querySelector("#canvas");
          var context = canvas.getContext("2d");
          var canvasMessages = document.getElementById("canvasMessages");
          this.contextMessages = canvasMessages.getContext("2d");
          context.drawImage(video, 0, 0, this.cvWidth, this.cvHeight);
          var imageData = context.getImageData(
            0,
            0,
            canvas.width,
            canvas.height
          );
          var d = imageData.data;
          var rgb = { r: 0, g: 0, b: 0 };
          for (var i = 0; i < d.length; i += 4) {
            rgb.r += d[i];
            rgb.g += d[i + 1];
            rgb.b += d[i + 2];
          }
          rgb.r = ~~(rgb.r / (d.length / 4));
          rgb.g = ~~(rgb.g / (d.length / 4));
          rgb.b = ~~(rgb.b / (d.length / 4));
          var brightness =
            Math.round(
              ((0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b) / 255) *
                100 *
                100
            ) / 100; // +'%'
          if (
            brightness > parseInt(this.brightnessVideoThreshold[0]) &&
            brightness < parseInt(this.brightnessVideoThreshold[1])
          ) {
            console.log("Luz optima");
            this.cleanShowInfoDetectionMessages(
              this.contextMessages,
              this.vWidth,
              this.vHeight
            );
            if (this.isDesktop) {
              this.showInfoDetectionMessages(
                this.contextMessages,
                this.identificationMessages.optimumBrightness,
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_NEUTRAL_BORDER_COLOR,
                this.INFO_NEUTRAL_COLOR,
                this.INFO_WHITE_TEXT
              );
            } else {
              this.showInfoDetectionMessagesBelow(
                this.contextMessages,
                this.obtainMessagesForMobile(
                  this.identificationMessages.optimumBrightness
                ),
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_NEUTRAL_BORDER_COLOR,
                this.INFO_NEUTRAL_COLOR,
                this.INFO_WHITE_TEXT,
                true
              );
            }
            setTimeout(() => {
              if (
                this.isIOS ||
                this.isIPad ||
                this.isSafari ||
                this.isIE11 ||
                this.isEdge
              ) {
                this.EventBus.$emit("startArchive");
              } else {
                this.initRecorder(stream);
              }
            }, 2000);
          } else if (brightness < parseInt(this.brightnessVideoThreshold[0])) {
            console.log("Luz por debajo del mímimo");
            this.cleanShowInfoDetectionMessages(
              this.contextMessages,
              this.vWidth,
              this.vHeight
            );
            if (this.isDesktop) {
              this.showInfoDetectionMessages(
                this.contextMessages,
                this.identificationMessages.minimumBrightness,
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_NEUTRAL_BORDER_COLOR,
                this.INFO_NEUTRAL_COLOR,
                this.INFO_WHITE_TEXT
              );
            } else {
              this.showInfoDetectionMessagesBelow(
                this.contextMessages,
                this.obtainMessagesForMobile(
                  this.identificationMessages.minimumBrightness
                ),
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_NEUTRAL_BORDER_COLOR,
                this.INFO_NEUTRAL_COLOR,
                this.INFO_WHITE_TEXT,
                true
              );
            }
            setTimeout(() => {
              this.averageBrightnessDetection(stream);
            }, 5000);
          } else if (brightness > parseInt(this.brightnessVideoThreshold[1])) {
            console.log("Luz por encima del máximo");
            this.cleanShowInfoDetectionMessages(
              this.contextMessages,
              this.vWidth,
              this.vHeight
            );
            if (this.isDesktop) {
              this.showInfoDetectionMessages(
                this.contextMessages,
                this.identificationMessages.maximumBrightness,
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_NEUTRAL_BORDER_COLOR,
                this.INFO_NEUTRAL_COLOR,
                this.INFO_WHITE_TEXT
              );
            } else {
              this.showInfoDetectionMessagesBelow(
                this.contextMessages,
                this.obtainMessagesForMobile(
                  this.identificationMessages.maximumBrightness
                ),
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_NEUTRAL_BORDER_COLOR,
                this.INFO_NEUTRAL_COLOR,
                this.INFO_WHITE_TEXT,
                true
              );
            }
            setTimeout(() => {
              this.averageBrightnessDetection(stream);
            }, 5000);
          }
        } else {
          setTimeout(() => {
            this.averageBrightnessDetection(stream);
          }, 500);
        }
      } else {
        if (
          this.isIOS ||
          this.isIPad ||
          this.isSafari ||
          this.isIE11 ||
          this.isEdge
        ) {
          this.EventBus.$emit("startArchive");
        } else {
          this.initRecorder(stream);
        }
      }
    },
    startIdentificationProcess() {
      if (this.doLivenessDetection) {
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.identificationMessages.livenessDetection,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_NEUTRAL_BORDER_COLOR,
          this.INFO_NEUTRAL_COLOR,
          this.INFO_WHITE_TEXT
        );
        this.livenessDetection();
      } else if (this.doFaceDetection) {
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.identificationMessages.faceDetection,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_NEUTRAL_BORDER_COLOR,
          this.INFO_NEUTRAL_COLOR,
          this.INFO_WHITE_TEXT
        );
        this.faceDetection();
      } else if (this.doFrontDetection) {
        this.frontDeepDetection();
      } else if (this.doBackDetection) {
        this.backDeepDetection();
      }
    },
    captureImageFromVideo() {
      if (
        !this.isIOS &&
        !this.isIPad &&
        !this.isSafari &&
        !this.isIE11 &&
        !this.isEdge
      ) {
        var canvas = document.querySelector("#canvas");
        canvas
          .getContext("2d")
          .drawImage(this.video, 0, 0, this.cvWidth, this.cvHeight);
        return canvas.toDataURL();
      }
      var imgB64 = this.publisher.getImgData();
      return `${"data:image/jpgbase64,"}${imgB64}`;
    },
    livenessDetection() {
      // this.EventBus.$emit('livenessDetection', true); // Steppers
      // live.mainLifeTest(this.vWidth, this.vHeight, this);
      // this.$on('testLive', (data) => {
      //   if (data.finish) {
      //     this.cleanShowInfoDetectionMessages(this.contextMessages, this.vWidth, this.vHeight);
      //     this.showInfoDetectionMessages(this.contextMessages, this.identificationMessages.livenessDetectionFinish, this.INFO_WIDTH, this.INFO_HEIGHT,
      //                                     this.INFO_SUCCESS_BORDER_COLOR, this.INFO_SUCCESS_COLOR, this.INFO_BLACK_TEXT);
      //     this.drawCheckMark('canvasCheckMark');
      //     setTimeout(() => {
      //         this.cleanCanvas(this.contextCheckMark, this.vWidth, this.vHeight);
      //         this.cleanShowInfoDetectionMessages(this.contextMessages, this.vWidth, this.vHeight);
      //         this.showInfoDetectionMessages(this.contextMessages, this.identificationMessages.faceDetection, this.INFO_WIDTH, this.INFO_HEIGHT,
      //                                         this.INFO_NEUTRAL_BORDER_COLOR, this.INFO_NEUTRAL_COLOR, this.INFO_WHITE_TEXT);
      //         this.drawFaceCircleOverVideo();
      //         this.faceDetection();
      //     }, 2000);
      //   }
      // });
    },
    faceDetection() {
      this.face.type = "face";
      this.face.uuid = this.operationUuid;
      this.face.returnFaceImg = this.returnFaceImage;
      this.face.customerid = this.customerId;
      this.face.widthFaceRect = this.withFaceRect;
      this.face.biometry = this.biometry;
      this.face.blink = this.blink;
      this.face.imgb64 = this.captureImageFromVideo();
      this.face.detectBrightnessInImage = this.detectBrightnessInImage;
      this.face.brightnessImageThreshold = this.brightnessImageThreshold;
      this.face.detectBlurInImage = this.detectBlurInImage;
      this.face.blurImageThreshold = this.blurImageThreshold;
      this.$http.defaults.headers.common.Authorization = this.token;
      this.$http
        .post(
          `${this.endPointVideo}${"/detection/face/"}${this.operationUuid}`,
          this.face,
          { headers: { "Content-type": "Application/json" } }
        )
        .then(
          responseSuccess => {
            if (!this.isIdentificationEnded && responseSuccess.data.detected) {
              let identificationData = this.prepareIdentificationData(
                responseSuccess.data,
                "FACE",
                this.returnFaceImage,
                this.biometry
              );
              this.saveDataInCapturedImage(identificationData);
              this.drawCheckMark("canvasCheckMark");
              this.cleanShowInfoDetectionMessages(
                this.contextMessages,
                this.vWidth,
                this.vHeight
              );
              this.showInfoDetectionMessages(
                this.contextMessages,
                this.identificationMessages.faceDetectionFinish,
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_SUCCESS_BORDER_COLOR,
                this.INFO_SUCCESS_COLOR,
                this.INFO_BLACK_TEXT
              );
              this.isFaceDetection = false;
              this.isDocumentTypeDetection = true;
              if (
                !this.isIOS &&
                !this.isIPad &&
                !this.isSafari &&
                !this.isIE11 &&
                !this.isEdge &&
                !this.isDesktop
              ) {
                setTimeout(() => {
                  this.closeCamera();
                  this.saveFirstBlob();
                  this.faceTimeoutToFrontDetection = 5000;
                  setTimeout(() => {
                    document
                      .getElementById("video")
                      .classList.add("videoNoTransition");
                    document
                      .getElementById("video")
                      .classList.remove("videoTransition");
                  }, 2000);
                }, 2000);
              } else if (this.isIOS && !this.isIPad && !this.isDesktop) {
                setTimeout(() => {
                  this.publisher.cycleVideo();
                  document
                    .getElementById("video")
                    .classList.remove("videoNoTransition");
                  document
                    .getElementById("video")
                    .classList.add("videoTransition");
                }, 2000);
              }
              setTimeout(() => {
                this.cleanShowInfoDetectionMessages(
                  this.contextMessages,
                  this.vWidth,
                  this.vHeight
                );
                this.showInfoDetectionMessages(
                  this.contextMessages,
                  this.identificationMessages.frontDetection,
                  this.INFO_WIDTH,
                  this.INFO_HEIGHT,
                  this.INFO_NEUTRAL_BORDER_COLOR,
                  this.INFO_NEUTRAL_COLOR,
                  this.INFO_WHITE_TEXT
                );
                this.cleanCanvas(
                  this.contextCheckMark,
                  this.vWidth,
                  this.vHeight
                );
                this.EventBus.$emit("faceDetection", true); // Steppers
                // var canvasGuide = document.getElementById('canvasGuide');
                // this.contextGuide = canvasGuide.getContext('2d');
                // this.insertCanvasOverVideo(canvasGuide, this.contextGuide, this.vWidth, this.vHeight, ar.arWidth, ar.arHeight, co.x, co.y, 'red');
                this.frontDeepDetection();
              }, this.faceTimeoutToFrontDetection);
              if (this.snackBar) {
                this.$showSnackBar(
                  "snackbar-success",
                  this.snackBarMessages.successFaceMsg
                );
              }
            } else if (!this.isIdentificationEnded) {
              this.cleanShowInfoDetectionMessages(
                this.contextMessages,
                this.vWidth,
                this.vHeight
              );
              // this.showInfoDetectionMessages(this.contextMessages, this.identificationMessages.faceDetectionClose, this.INFO_WIDTH, this.INFO_HEIGHT,
              //                                   this.INFO_NEUTRAL_BORDER_COLOR, this.INFO_NEUTRAL_COLOR, this.INFO_WHITE_TEXT, this.messagesPositionTop);
              if (responseSuccess.data.brightness) {
                if (this.isDesktop) {
                  this.showInfoDetectionMessages(
                    this.contextMessages,
                    this.identificationMessages.brightnessImage,
                    this.INFO_WIDTH,
                    this.INFO_HEIGHT,
                    this.INFO_NEUTRAL_BORDER_COLOR,
                    this.INFO_NEUTRAL_COLOR,
                    this.INFO_WHITE_TEXT,
                    false,
                    this.messagesPositionTop
                  );
                } else {
                  this.showInfoDetectionMessagesDouble(
                    this.contextMessages,
                    this.obtainMessagesForMobile(
                      this.identificationMessages.brightnessImage
                    ),
                    this.INFO_WIDTH,
                    this.INFO_HEIGHT,
                    this.INFO_NEUTRAL_BORDER_COLOR,
                    this.INFO_NEUTRAL_COLOR,
                    this.INFO_WHITE_TEXT,
                    true,
                    this.messagesPositionTop
                  );
                }
              } else if (responseSuccess.data.blur) {
                if (this.isDesktop) {
                  this.showInfoDetectionMessages(
                    this.contextMessages,
                    this.identificationMessages.blurFaceImage,
                    this.INFO_WIDTH,
                    this.INFO_HEIGHT,
                    this.INFO_NEUTRAL_BORDER_COLOR,
                    this.INFO_NEUTRAL_COLOR,
                    this.INFO_WHITE_TEXT,
                    this.messagesPositionTop
                  );
                } else {
                  this.showInfoDetectionMessagesDouble(
                    this.contextMessages,
                    this.obtainMessagesForMobile(
                      this.identificationMessages.blurFaceImage
                    ),
                    this.INFO_WIDTH,
                    this.INFO_HEIGHT,
                    this.INFO_NEUTRAL_BORDER_COLOR,
                    this.INFO_NEUTRAL_COLOR,
                    this.INFO_WHITE_TEXT,
                    true,
                    this.messagesPositionTop
                  );
                }
              }
              this.faceDetection();
            }
          },
          responseError => {
            if (!this.isIdentificationEnded) {
              this.faceDetection();
            }
          }
        );
    },
    async saveFirstBlob() {
      await this.recorder.stopRecording();
      let firstBlob = await this.recorder.getBlob();
      this.blobsArray.push(firstBlob);
      this.EventBus.$emit("changeCamera");
    },
    drawFaceCircleOverVideo() {
      var canvas = document.getElementById("canvasFaceCircle");
      this.contextFaceCircle = canvas.getContext("2d");
      var x = canvas.width / 2;
      var y = canvas.height / 2;
      var angle = 0;
      var circleCountSmall = 57;
      var startAngle = 1 * Math.PI + angle;
      var endAngle = 1.01 * Math.PI + angle;
      if (this.isDesktop) {
        var radius = canvas.width / 3.7;
      } else {
        if (this.isPortrait) {
          var radius = canvas.width / 2.7;
        } else {
          var radius = canvas.width / 3.7;
        }
      }
      for (var c = 0; c < circleCountSmall; c++) {
        this.contextFaceCircle.strokeStyle = "#EC0000";
        if (this.isDesktop) {
          this.contextFaceCircle.lineWidth = 30;
        } else {
          this.contextFaceCircle.lineWidth = 20;
        }
        this.contextFaceCircle.beginPath();
        this.contextFaceCircle.arc(x, y, radius, startAngle, endAngle);
        this.contextFaceCircle.stroke();
        this.contextFaceCircle.closePath();
        startAngle += 0.035 * Math.PI;
        endAngle += 0.035 * Math.PI;
      }
    },
    drawRectanglesOverVideo(canvasId, { x1, x2, y1, y2 }, type) {
      this.canvasRect = document.getElementById(canvasId);
      this.contextRect = this.canvasRect.getContext("2d");
      this.cleanCanvas(this.contextRect, this.vWidth, this.vHeight);
      this.contextRect.beginPath();
      this.contextRect.lineWidth = "3";
      this.contextRect.strokeStyle = "rgb(109, 230, 186)";
      if (type === "face") {
        if (this.isDesktop) {
          if (this.isEdge) {
            this.contextRect.rect(
              this.vWidth - x1 - (x2 - x1),
              y1 + 60,
              x2 - x1,
              y2 - y1
            );
          } else {
            this.contextRect.rect(
              this.vWidth - x1 - (x2 - x1),
              y1,
              x2 - x1,
              y2 - y1
            );
          }
        } else {
          this.contextRect.rect(
            this.vWidth - x1 / 2 - (x2 - x1) / 2,
            y1 / 2,
            (x2 - x1) / 2,
            (y2 - y1) / 2
          );
        }
      } else if (type === "rectangle") {
        if (this.isDesktop) {
          this.contextRect.rect(x1, y1, x2 - x1, y2 - y1);
        } else {
          this.contextRect.rect(x1 / 2, y1 / 2, (x2 - x1) / 2, (y2 - y1) / 2);
        }
      } else if (type === "front" || type === "hologram" || type === "back") {
        if (this.isDesktop) {
          if (this.isEdge) {
            // Las capturas en Edge y Firefox con opentok son 640x360
            this.contextRect.rect(this.vWidth - x2 - y1, x1 + 60, y1, y2); // flip 180 horizontal
          } else {
            this.contextRect.rect(this.vWidth - x2 - y1, x1, y1, y2); // flip 180 horizontal
          }
        } else {
          this.contextRect.rect(x2 / 2, x1 / 2, y1 / 2, y2 / 2);
        }
      }
      this.contextRect.stroke();
    },
    faceBiometryValidation(confidence) {
      if (confidence >= this.biometryConfidence) {
        this.EventBus.$emit("biometryDetection", true);
        this.$emit("biometry");
      } else {
        if (
          this.isIOS ||
          this.isIPad ||
          this.isSafari ||
          this.isIE11 ||
          this.isEdge
        ) {
          this.EventBus.$emit("stopRecording");
          this.logicPostStopOpenTok();
        } else {
          this.stopRecording();
        }
        this.biometryConfidence = this.biometryConfidence * 100;
        clearTimeout(this.videoTimeout);
        // this.isBiometryBlocking = true;
        this.isIdentificationEnded = true;
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.identificationMessages.biometryBlocking,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_ERROR_BORDER_COLOR,
          this.INFO_ERROR_COLOR,
          this.INFO_WHITE_TEXT
        );
        this.$emit("biometryBlocking");
        this.$emit("error", "Biometry blocking");
      }
    },
    frontDeepDetection() {
      this.front.uuid = this.operationUuid;
      this.front.returnFrontImg = this.returnFrontImage;
      this.front.returnFrontOcr = this.returnFrontOcr;
      this.front.dni = this.dni;
      this.front.biometry = this.biometry;
      this.front.customerid = this.customerId;
      this.front.hologram = this.hologram;
      this.front.isPortrait = this.isPortrait;
      this.front.imgb64 = this.captureImageFromVideo();
      this.front.frontConfidence = this.frontConfidence;
      this.front.detectBrightnessInImage = this.detectBrightnessInImage;
      this.front.brightnessImageThreshold = this.brightnessImageThreshold;
      this.front.detectBlurInImage = this.detectBlurInImage;
      this.front.blurImageThreshold = this.blurImageThreshold;
      // Necessary to passport
      this.front.returnPassportImg = this.returnPassportImage;
      this.front.returnMrzImg = this.returnPassportMrzImage;
      this.$http.defaults.headers.common.Authorization = this.token;
      this.$http
        .post(
          `${this.endPointVideo}${"/detection/ml/front/"}${this.operationUuid}`,
          this.front,
          { headers: { "Content-type": "Application/json" } }
        )
        .then(
          responseSuccess => {
            let document = "",
              detected = false;
            if (responseSuccess.data.length > 1) {
              // DNI & HOLOGRAM
              if (
                responseSuccess.data[0].detected &&
                responseSuccess.data[1].detected &&
                (responseSuccess.data[0].documenttype.indexOf("anverso") !==
                  -1 ||
                  responseSuccess.data[0].documenttype.indexOf("front") !==
                    -1 ||
                  responseSuccess.data[1].documenttype.indexOf("anverso") !==
                    -1 ||
                  responseSuccess.data[1].documenttype.indexOf("front") !== -1)
              ) {
                this.logicDetectedFrontDocument(responseSuccess.data);
                document = "no-passport";
                detected = true;
              }
            } else if (responseSuccess.data.length === 1) {
              // PASSPORT OR OTHER DOCUMENTS
              if (
                responseSuccess.data[0].detected &&
                responseSuccess.data[0].documenttype === "pasaporte"
              ) {
                this.logicDetectedFrontDocument(responseSuccess.data);
                document = "passport";
                detected = true;
              } else if (
                responseSuccess.data[0].detected &&
                responseSuccess.data[0].documenttype.indexOf("pasaporte") ===
                  -1 &&
                responseSuccess.data[0].documenttype.indexOf("dni") === -1
              ) {
                this.logicDetectedFrontDocument(responseSuccess.data);
                document = "no-passport";
                detected = true;
              }
            }
            if (
              !this.isIdentificationEnded &&
              detected &&
              document === "no-passport"
            ) {
              // && (responseSuccess.data.documenttype === 'dni_3_anverso' || responseSuccess.data.documenttype === 'dni_2_anverso')
              this.logicPostDetectFront();
            } else if (
              !this.isIdentificationEnded &&
              detected &&
              document === "passport"
            ) {
              this.drawCheckMark("canvasCheckMark");
              this.cleanShowInfoDetectionMessages(
                this.contextMessages,
                this.vWidth,
                this.vHeight
              );
              this.showInfoDetectionMessages(
                this.contextMessages,
                this.identificationMessages.passportDetectionFinish,
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_SUCCESS_BORDER_COLOR,
                this.INFO_SUCCESS_COLOR,
                this.INFO_BLACK_TEXT
              );
              this.EventBus.$emit("passportDetection", true); // Steppers
              if (
                this.isIOS ||
                this.isIPad ||
                this.isSafari ||
                this.isIE11 ||
                this.isEdge
              ) {
                this.EventBus.$emit("stopRecording");
                this.logicPostStopOpenTok();
              } else {
                this.stopRecording();
              }
              setTimeout(() => {
                this.cleanCanvas(
                  this.contextCheckMark,
                  this.vWidth,
                  this.vHeight
                );
                this.cleanShowInfoDetectionMessages(
                  this.contextMessages,
                  this.vWidth,
                  this.vHeight
                );
                this.showInfoDetectionMessages(
                  this.contextMessages,
                  this.identificationMessages.identificationFinish,
                  this.INFO_WIDTH,
                  this.INFO_HEIGHT,
                  this.INFO_SUCCESS_BORDER_COLOR,
                  this.INFO_SUCCESS_COLOR,
                  this.INFO_BLACK_TEXT
                );
                // document.querySelector("esign-video-identification").response = this.snackBarMessages.endVideoIdentificationMsg;
                if (this.snackBar) {
                  this.$showSnackBar(
                    "snackbar-success",
                    this.snackBarMessages.endVideoIdentificationMsg
                  );
                }
              }, 2000);
            } else if (!this.isIdentificationEnded) {
              if (responseSuccess.data.length > 1) {
                if (
                  responseSuccess.data[0].documenttype.indexOf("anverso") !==
                    -1 ||
                  responseSuccess.data[0].documenttype.indexOf("front") !== -1
                ) {
                  var index = 0;
                } else if (
                  responseSuccess.data[1].documenttype.indexOf("anverso") !==
                    -1 ||
                  responseSuccess.data[1].documenttype.indexOf("front") !== -1
                ) {
                  var index = 1;
                }
                this.cleanShowInfoDetectionMessages(
                  this.contextMessages,
                  this.vWidth,
                  this.vHeight
                );
                // this.showInfoDetectionMessages(this.contextMessages, this.identificationMessages.frontDetectionAdjust, this.INFO_WIDTH, this.INFO_HEIGHT,
                //                                 this.INFO_NEUTRAL_BORDER_COLOR, this.INFO_NEUTRAL_COLOR, this.INFO_WHITE_TEXT, this.messagesPositionTop);
                if (responseSuccess.data[index].brightness) {
                  if (this.isDesktop) {
                    this.showInfoDetectionMessages(
                      this.contextMessages,
                      this.identificationMessages.brightnessImage,
                      this.INFO_WIDTH,
                      this.INFO_HEIGHT,
                      this.INFO_NEUTRAL_BORDER_COLOR,
                      this.INFO_NEUTRAL_COLOR,
                      this.INFO_WHITE_TEXT,
                      false,
                      this.messagesPositionTop
                    );
                  } else {
                    this.showInfoDetectionMessagesDouble(
                      this.contextMessages,
                      this.obtainMessagesForMobile(
                        this.identificationMessages.brightnessImage
                      ),
                      this.INFO_WIDTH,
                      this.INFO_HEIGHT,
                      this.INFO_NEUTRAL_BORDER_COLOR,
                      this.INFO_NEUTRAL_COLOR,
                      this.INFO_WHITE_TEXT,
                      true,
                      this.messagesPositionTop
                    );
                  }
                } else if (responseSuccess.data[index].blur) {
                  if (this.isDesktop) {
                    this.showInfoDetectionMessages(
                      this.contextMessages,
                      this.identificationMessages.blurDocumentImage,
                      this.INFO_WIDTH,
                      this.INFO_HEIGHT,
                      this.INFO_NEUTRAL_BORDER_COLOR,
                      this.INFO_NEUTRAL_COLOR,
                      this.INFO_WHITE_TEXT,
                      this.messagesPositionTop
                    );
                  } else {
                    this.showInfoDetectionMessagesDouble(
                      this.contextMessages,
                      this.obtainMessagesForMobile(
                        this.identificationMessages.blurDocumentImage
                      ),
                      this.INFO_WIDTH,
                      this.INFO_HEIGHT,
                      this.INFO_NEUTRAL_BORDER_COLOR,
                      this.INFO_NEUTRAL_COLOR,
                      this.INFO_WHITE_TEXT,
                      true,
                      this.messagesPositionTop
                    );
                  }
                }
                this.frontDeepDetection();
              } else {
                this.frontDeepDetection();
              }
            } else {
              this.frontDeepDetection();
            }
          },
          responseError => {
            if (!this.isIdentificationEnded) {
              this.cleanShowInfoDetectionMessages(
                this.contextMessages,
                this.vWidth,
                this.vHeight
              );
              this.showInfoDetectionMessages(
                this.contextMessages,
                this.identificationMessages.frontDetectionAdjust,
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_NEUTRAL_BORDER_COLOR,
                this.INFO_NEUTRAL_COLOR,
                this.INFO_WHITE_TEXT
              );
              this.frontDeepDetection();
            }
          }
        );
    },
    logicDetectedFrontDocument(data) {
      data.forEach((document, index) => {
        let identificationData, mrzData;
        if (
          document.documenttype.indexOf("anverso") !== -1 ||
          document.documenttype.indexOf("front") !== -1
        ) {
          identificationData = this.prepareIdentificationData(
            document,
            "DNIFRONT",
            this.returnFrontImage,
            this.biometry
          );
        } else if (document.documenttype.indexOf("hologram") !== -1) {
          identificationData = this.prepareIdentificationData(
            document,
            "HOLOGRAM",
            this.returnFrontImage,
            this.biometry
          );
        } else if (document.documenttype.indexOf("pasaporte") !== -1) {
          identificationData = this.prepareIdentificationData(
            document,
            "PASSPORT",
            this.returnFrontImage,
            this.biometry
          );
          mrzData = this.prepareIdentificationData(
            document,
            "PASSPORTMRZ",
            this.returnPassportMrzImage,
            false
          );
        }
        this.saveDataInCapturedImage(identificationData);
        if (document.documenttype.indexOf("pasaporte") !== -1) {
          this.saveDataInCapturedImage(mrzData);
        }
        if (document.documenttype.indexOf("hologram") === -1) {
          // No es holograma
          if (this.biometry && this.biometryBlocking) {
            this.faceBiometryValidation(document.biometryData.confidence);
          } else if (this.biometry && !this.biometryBlocking) {
            this.EventBus.$emit("biometryDetection", true); // Steppers
          }
        }
      });
    },
    logicPostDetectFront() {
      if (!this.isIdentificationEnded) {
        this.drawCheckMark("canvasCheckMark");
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.identificationMessages.frontDetectionFinish,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_SUCCESS_BORDER_COLOR,
          this.INFO_SUCCESS_COLOR,
          this.INFO_BLACK_TEXT
        );
        this.EventBus.$emit("frontDetection", true); // Steppers
        this.isFrontDetection = false;
        this.isBackDetection = true;
        setTimeout(() => {
          this.cleanShowInfoDetectionMessages(
            this.contextMessages,
            this.vWidth,
            this.vHeight
          );
          this.showInfoDetectionMessages(
            this.contextMessages,
            this.identificationMessages.backDetection,
            this.INFO_WIDTH,
            this.INFO_HEIGHT,
            this.INFO_NEUTRAL_BORDER_COLOR,
            this.INFO_NEUTRAL_COLOR,
            this.INFO_WHITE_TEXT
          );
        }, 2500);
        setTimeout(() => {
          this.cleanCanvas(this.contextCheckMark, this.vWidth, this.vHeight);
          this.backDeepDetection();
        }, 2000);
      } else if (!this.isIdentificationEnded) {
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.identificationMessages.frontDetectionAdjust,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_NEUTRAL_BORDER_COLOR,
          this.INFO_NEUTRAL_COLOR,
          this.INFO_WHITE_TEXT
        );
        this.frontDeepDetection();
      }
    },
    backDeepDetection() {
      this.back.uuid = this.operationUuid;
      this.back.returnBackImg = this.returnBackImage;
      this.back.returnBackOcr = this.returnBackOcr;
      this.back.dni = this.dni;
      this.back.customerid = this.customerId;
      this.back.isPortrait = this.isPortrait;
      this.back.imgb64 = this.captureImageFromVideo();
      this.back.backConfidence = this.backConfidence;
      this.back.detectBrightnessInImage = this.detectBrightnessInImage;
      this.back.brightnessImageThreshold = this.brightnessImageThreshold;
      this.back.detectBlurInImage = this.detectBlurInImage;
      this.back.blurImageThreshold = this.blurImageThreshold;
      this.$http.defaults.headers.common.Authorization = this.token;
      this.$http
        .post(
          `${this.endPointVideo}${"/detection/ml/back/"}${this.operationUuid}`,
          this.back,
          { headers: { "Content-type": "Application/json" } }
        )
        .then(
          responseSuccess => {
            if (responseSuccess.data.length > 0) {
              if (
                !this.isIdentificationEnded &&
                responseSuccess.data[0].detected &&
                (responseSuccess.data[0].documenttype.indexOf("reverso") !==
                  -1 ||
                  responseSuccess.data[0].documenttype.indexOf("back") !== -1)
              ) {
                // && (responseSuccess.data.documenttype === 'dni_3_reverso' || responseSuccess.data.documenttype === 'dni_2_reverso')
                let identificationData = this.prepareIdentificationData(
                  responseSuccess.data[0],
                  "DNIBACK",
                  this.returnBackImage,
                  false
                );
                this.saveDataInCapturedImage(identificationData);
                this.logicPostDetectBack();
              } else if (!this.isIdentificationEnded) {
                this.cleanShowInfoDetectionMessages(
                  this.contextMessages,
                  this.vWidth,
                  this.vHeight
                );
                // this.showInfoDetectionMessages(this.contextMessages, this.identificationMessages.backDetectionAdjust, this.INFO_WIDTH, this.INFO_HEIGHT,
                //                                 this.INFO_NEUTRAL_BORDER_COLOR, this.INFO_NEUTRAL_COLOR, this.INFO_WHITE_TEXT, this.messagesPositionTop);
                if (responseSuccess.data[0].brightness) {
                  if (this.isDesktop) {
                    this.showInfoDetectionMessages(
                      this.contextMessages,
                      this.identificationMessages.brightnessImage,
                      this.INFO_WIDTH,
                      this.INFO_HEIGHT,
                      this.INFO_NEUTRAL_BORDER_COLOR,
                      this.INFO_NEUTRAL_COLOR,
                      this.INFO_WHITE_TEXT,
                      false,
                      this.messagesPositionTop
                    );
                  } else {
                    this.showInfoDetectionMessagesDouble(
                      this.contextMessages,
                      this.obtainMessagesForMobile(
                        this.identificationMessages.brightnessImage
                      ),
                      this.INFO_WIDTH,
                      this.INFO_HEIGHT,
                      this.INFO_NEUTRAL_BORDER_COLOR,
                      this.INFO_NEUTRAL_COLOR,
                      this.INFO_WHITE_TEXT,
                      true,
                      this.messagesPositionTop
                    );
                  }
                } else if (responseSuccess.data[0].blur) {
                  if (this.isDesktop) {
                    this.showInfoDetectionMessages(
                      this.contextMessages,
                      this.identificationMessages.blurDocumentImage,
                      this.INFO_WIDTH,
                      this.INFO_HEIGHT,
                      this.INFO_NEUTRAL_BORDER_COLOR,
                      this.INFO_NEUTRAL_COLOR,
                      this.INFO_WHITE_TEXT,
                      this.messagesPositionTop
                    );
                  } else {
                    this.showInfoDetectionMessagesDouble(
                      this.contextMessages,
                      this.obtainMessagesForMobile(
                        this.identificationMessages.blurDocumentImage
                      ),
                      this.INFO_WIDTH,
                      this.INFO_HEIGHT,
                      this.INFO_NEUTRAL_BORDER_COLOR,
                      this.INFO_NEUTRAL_COLOR,
                      this.INFO_WHITE_TEXT,
                      true,
                      this.messagesPositionTop
                    );
                  }
                }
                this.backDeepDetection();
              } else {
                this.backDeepDetection();
              }
            } else {
              this.backDeepDetection();
            }
          },
          responseError => {
            if (!this.isIdentificationEnded) {
              this.cleanShowInfoDetectionMessages(
                this.contextMessages,
                this.vWidth,
                this.vHeight
              );
              this.showInfoDetectionMessages(
                this.contextMessages,
                this.identificationMessages.backDetectionAdjust,
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_NEUTRAL_BORDER_COLOR,
                this.INFO_NEUTRAL_COLOR,
                this.INFO_WHITE_TEXT
              );
              this.backDeepDetection();
            }
          }
        );
    },
    logicPostDetectBack() {
      if (!this.isIdentificationEnded) {
        // document.querySelector("esign-video-identification").status = 200;
        // document.querySelector("esign-video-identification").response = this.snackBarMessages.successBackMsg;
        if (this.snackBar) {
          this.$showSnackBar(
            "snackbar-success",
            this.snackBarMessages.successBackMsg
          );
        }
        this.drawCheckMark("canvasCheckMark");
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.identificationMessages.backDetectionFinish,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_SUCCESS_BORDER_COLOR,
          this.INFO_SUCCESS_COLOR,
          this.INFO_BLACK_TEXT
        );
        this.EventBus.$emit("backDetection", true); // Steppers
        this.isBackDetection = false;
        this.isIdentificationEnded = true;
        if (
          this.isIOS ||
          this.isIPad ||
          this.isSafari ||
          this.isIE11 ||
          this.isEdge
        ) {
          this.endVideoTime = new Date();
          this.EventBus.$emit("stopRecording");
          this.logicPostStopOpenTok();
        } else {
          this.stopRecording();
        }
        clearTimeout(this.endVideoTimeout);
        if (this.snackBar) {
          this.$showSnackBar(
            "snackbar-success",
            this.snackBarMessages.successBackMsg
          );
        }
        setTimeout(() => {
          this.cleanCanvas(this.contextCheckMark, this.vWidth, this.vHeight);
          this.cleanShowInfoDetectionMessages(
            this.contextMessages,
            this.vWidth,
            this.vHeight
          );
          this.showInfoDetectionMessages(
            this.contextMessages,
            this.identificationMessages.identificationFinish,
            this.INFO_WIDTH,
            this.INFO_HEIGHT,
            this.INFO_SUCCESS_BORDER_COLOR,
            this.INFO_SUCCESS_COLOR,
            this.INFO_BLACK_TEXT
          );
          // document.querySelector("esign-video-identification").status = 200;
          // document.querySelector("esign-video-identification").response = this.snackBarMessages.endVideoIdentificationMsg;
          if (this.snackBar) {
            this.$showSnackBar(
              "snackbar-success",
              this.snackBarMessages.endVideoIdentificationMsg
            );
          }
        }, 2000);
      } else if (!this.isIdentificationEnded) {
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.identificationMessages.backDetectionAdjust,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_NEUTRAL_BORDER_COLOR,
          this.INFO_NEUTRAL_COLOR,
          this.INFO_WHITE_TEXT
        );
        this.backDeepDetection();
      }
    },
    prepareIdentificationData(response, type, image, biometry) {
      let identificationData = {};
      identificationData.operationUuid = this.operationUuid;
      identificationData.documentType = type;
      if (type === "DNIFRONT" && biometry) {
        response.biometryData.frontConfidence = response.confidence;
      } else if (type === "DNIFRONT" && !biometry) {
        response.biometryData = {};
        response.biometryData.frontConfidence = response.confidence;
        identificationData.metadata = JSON.stringify(response.biometryData);
      }
      if (
        (type === "FACE" || type === "DNIFRONT" || type === "PASSPORT") &&
        biometry
      ) {
        identificationData.metadata = JSON.stringify(response.biometryData);
      }
      if (type === "HOLOGRAM" && this.doHologramDetection) {
        identificationData.metadata = JSON.stringify(response.confidence);
      }
      if (
        (type === "DNIBACK" || type === "PASSPORTMRZ") &&
        (this.returnBackOcr || this.returnPassportMrzOcr)
      ) {
        if (typeof response.ocr !== "undefined") {
          response.ocr.backConfidence = response.confidence;
          identificationData.metadata = JSON.stringify(response.ocr);
        }
      } else if (
        (type === "DNIBACK" || type === "PASSPORTMRZ") &&
        (!this.returnBackOcr || !this.returnPassportMrzOcr)
      ) {
        response.ocr.backConfidence = response.confidence;
        identificationData.metadata = JSON.stringify(response.ocr);
      }
      if (image && type !== "PASSPORTMRZ") {
        identificationData.documentB64 = response.imagebase64.split(",")[1];
      } else if (image && type === "PASSPORTMRZ") {
        identificationData.documentB64 = response.imagemrzbase64.split(",")[1];
      }
      return identificationData;
    },
    saveDataInCapturedImage(identificationData) {
      this.$http.defaults.headers.common.Authorization = this.token;
      this.$http
        .post(
          `${this.endPoint}${"saveidentificationdata/"}${
            this.operationUuid
          }${"/"}${this.videoUuid}`,
          identificationData
        )
        .then(
          () => {
            console.log("Captured Data OK");
          },
          () => {
            console.log("Captured Data KO");
          }
        );
    },
    cleanCanvas(context, width, height) {
      context.clearRect(0, 0, width, height);
    },
    showInfoDetectionMessages(
      contextMsg,
      message,
      width,
      height,
      colorRect,
      colorFillRect,
      colorText
    ) {
      contextMsg.beginPath();
      if (this.isDesktop) {
        contextMsg.fillStyle = "rgba(0, 0, 0, 0.4)";
        contextMsg.fillRect(0, 0, this.vWidth, 40);
        contextMsg.font = "bold 20px Open Sans";
        contextMsg.textAlign = "center";
        contextMsg.textBaseline = "middle";
        contextMsg.fillStyle = "white";
        contextMsg.fillText(message, 49 + width / 2, 40 / 2);
      } else {
        contextMsg.fillStyle = "rgba(0, 0, 0, 0.4)";
        contextMsg.fillRect(0, 0, this.vWidth, 30);
        if (this.isPortrait) {
          contextMsg.font = "bold 15px Open Sans";
        } else {
          contextMsg.font = "bold 16px Open Sans";
        }
        contextMsg.textAlign = "center";
        contextMsg.textBaseline = "middle";
        contextMsg.fillStyle = "white";
        contextMsg.fillText(message, 10 + width / 2, 30 / 2);
      }
      contextMsg.stroke();
    },
    obtainMessagesForMobile(originalMessage) {
      var messages = originalMessage.match(/\S+/g);
      var spaceCount = originalMessage.split(" ").length - 1;
      var limit = Math.floor(spaceCount / 2 + 1);

      var finalmessage = "";
      for (var i = 0; i < spaceCount + 1; i++) {
        if (i === limit) {
          finalmessage = finalmessage + "\n" + messages[i];
        } else {
          finalmessage = finalmessage + messages[i];
        }
        finalmessage = finalmessage + " ";
      }
      return finalmessage.trim();
    },
    showInfoDetectionMessagesBelow(
      contextMsg,
      message,
      width,
      height,
      colorRect,
      colorFillRect,
      colorText,
      top
    ) {
      contextMsg.beginPath();
      if (this.isDesktop) {
        contextMsg.fillStyle = "rgba(0, 0, 0, 0.4)";
        contextMsg.fillRect(0, 40, this.vWidth, 40);
        contextMsg.font = "bold 20px Open Sans";
        contextMsg.textAlign = "center";
        contextMsg.textBaseline = "middle";
        contextMsg.fillStyle = "white";
        contextMsg.fillText(message, 49 + width / 2, 40 / 2 + 40);
      } else {
        contextMsg.fillStyle = "rgba(0, 0, 0, 0.4)";
        if (top) {
          contextMsg.fillRect(0, 0, this.vWidth, 60);
        } else {
          contextMsg.fillRect(0, 30, this.vWidth, 60);
        }
        if (this.isPortrait) {
          contextMsg.font = "bold 15px Open Sans";
        } else {
          contextMsg.font = "bold 16px Open Sans";
        }
        contextMsg.textAlign = "center";
        contextMsg.textBaseline = "middle";
        contextMsg.fillStyle = "white";
        if (message.indexOf("\n") !== -1 && top) {
          var messages = message.split("\n");
          contextMsg.fillText(messages[0], 10 + width / 2, 30 / 2);
          contextMsg.fillText(messages[1], 10 + width / 2, 30 / 2 + 30);
        } else if (message.indexOf("\n") !== -1 && !top) {
          var messages = message.split("\n");
          contextMsg.fillText(messages[0], 10 + width / 2, 30 / 2 + 30);
          contextMsg.fillText(messages[1], 10 + width / 2, 30 / 2 + 30 * 2);
        } else {
          contextMsg.fillText(message, 10 + width / 2, 30 / 2 + 30);
        }
      }
      contextMsg.stroke();
    },
    cleanShowInfoDetectionMessages(contextMsg, width, height) {
      contextMsg.clearRect(0, 0, width, height);
    },
    drawCheckMark(id) {
      var start = 40;
      var mid = 65;
      var end = 120;
      var width = 5;
      var leftX = start;
      var leftY = start;
      var rightX = mid - width / 2.7;
      var rightY = mid + width / 2.7;
      var animationSpeed = 7;
      // get a reference to the canvas
      var canvasCheckMark = document.getElementById(id);
      this.contextCheckMark = canvasCheckMark.getContext("2d");
      this.contextCheckMark.lineWidth = width;
      // apply color of checkmark in html
      this.contextCheckMark.strokeStyle = "rgb(109, 230, 186)";
      for (var i = start; i < mid; i += 1) {
        var drawLeft = window.setTimeout(() => {
          this.contextCheckMark.beginPath();
          this.contextCheckMark.moveTo(start, start);
          this.contextCheckMark.lineTo(leftX, leftY);
          this.contextCheckMark.stroke();
          leftX += 1;
          leftY += 1;
        }, (1 + i * animationSpeed) / 3);
      }
      // draw right line
      for (var j = mid; j < end; j += 1) {
        var drawRight = window.setTimeout(() => {
          this.contextCheckMark.beginPath();
          this.contextCheckMark.moveTo(leftX, leftY);
          this.contextCheckMark.lineTo(rightX, rightY);
          this.contextCheckMark.stroke();
          rightX += 1;
          rightY -= 1;
        }, (1 + j * animationSpeed) / 3);
      }
    },
    async stopRecording() {
      this.endVideoTime = new Date();
      await this.recorder.stopRecording();
      setTimeout(async () => {
        var blob = await this.recorder.getBlob();
        if (!this.isDesktop) {
          this.blobsArray.push(blob);
          window.ConcatenateBlobs(
            this.blobsArray,
            this.blobsArray[0].type,
            concatenatedBlob => {
              var newBlob = concatenatedBlob;
              this.stopRecordCircle();
              this.sendBlobToServer(newBlob);
            }
          );
        } else {
          this.stopRecordCircle();
          this.sendBlobToServer(blob);
        }
      }, 2000);
    },
    closeCamera() {
      this.stream.getTracks().forEach(track => {
        track.stop();
      });
    },
    sendBlobToServer(blob) {
      let videoData = {};
      videoData.domainUuid = this.domainUuid;
      videoData.videoUuid = this.videoUuid;
      this.videoDuration = this.endVideoTime - this.startVideoTime;
      if (isNaN(this.videoDuration)) {
        videoData.videoDuration = 0;
      } else {
        videoData.videoDuration = this.videoDuration;
      }
      videoData.videoSize = blob.size;
      var reader = new FileReader();
      reader.onloadend = () => {
        videoData.videoBase64 = reader.result.split(",")[1];
        this.$emit("notify", "showLoading");
        if (this.loading) {
          this.showLoading();
        }
        clearTimeout(this.endVideoTimeout);
        this.$http.defaults.headers.common.Authorization = this.token;
        this.$http
          .post(
            `${this.endPoint}${"uploadblobwebm/"}${this.operationUuid}`,
            videoData
          )
          .then(
            responseSuccess => {
              if (this.loading) {
                this.hideLoading();
              }
              this.calculateVideoParams();
              if (!this.isBiometryBlocking) {
                this.EventBus.$emit("endIdentification", true); // Steppers
              }
              if (
                !this.isIOS &&
                !this.isIPad &&
                !this.isSafari &&
                !this.isIE11 &&
                !this.isEdge
              ) {
                console.log("close camera in send blob to server");
                this.closeCamera();
              }
              // document.querySelector("esign-video-identification").status = responseSuccess.status;
              // document.querySelector("esign-video-identification").response = this.saveVideoSuccess;
              if (this.snackBar) {
                this.$showSnackBar(
                  "snackbar-success",
                  this.snackBarMessages.saveVideoSuccess
                );
              }
              this.$emit("notify", "hideLoading");
              this.$emit("success", this.videoUuid);
            },
            responseError => {
              if (this.loading) {
                this.hideLoading();
              }
              if (this.snackBar) {
                this.$showSnackBar(
                  "snackbar-success",
                  this.snackBarMessages.saveVideoError
                );
              }
              if (
                !this.isIOS &&
                !this.isIPad &&
                !this.isSafari &&
                !this.isIE11 &&
                !this.isEdge
              ) {
                this.closeCamera();
              }
              // document.querySelector("esign-video-identification").status = responseError.response.status;
              // if (responseError.response.status === 401) {
              //   document.querySelector("esign-video-identification").response = "El token ha caducado.";
              // } else {
              //   document.querySelector("esign-video-identification").response = this.snackBarMessages.saveVideoError;
              // }
              this.$emit("notify", "hideLoading");
              this.$emit("error", "Can´t save video");
            }
          );
      };
      reader.readAsDataURL(blob);
    },
    logicPostStopOpenTok() {
      clearTimeout(this.endVideoTimeout);
      this.calculateVideoParams();
      if (!this.isBiometryBlocking) {
        this.EventBus.$emit("endIdentification", true); // Steppers
      }
      if (
        !this.isIOS &&
        !this.isIPad &&
        !this.isSafari &&
        !this.isIE11 &&
        !this.isEdge
      ) {
        console.log("close camera in send blob to server");
        this.closeCamera();
      }
      if (this.snackBar) {
        this.$emit("snackbar-success", {
          snackBarText: this.snackBarMessages.saveVideoSuccess,
          snackBarBtn: ""
        });
      }
      this.$store.commit("setVideoUuid", this.videoUuid);
    },
    calculateVideoParams() {
      this.$http
        .post(
          `${this.endPoint}${"identificationresult/"}${
            this.operationUuid
          }${"/"}${this.videoUuid}`
        )
        .then(
          () => {
            console.log(
              "Se ha realizado el calculo de la fórmula de la identificación"
            );
            setTimeout(() => {
              if (
                !this.isBiometryBlocking &&
                !this.errorArchiving &&
                !this.errorEnded &&
                !this.videoTimeoutReached
              ) {
                // this.EventBus.$emit('tabResumeIdentification')s
                this.$router.push({ name: "resumeIdentification" });
              }
            }, 1000);
          },
          () => {
            console.log(
              "Ha ocurrido un error al calcular la fórmula de la identificación"
            );
            // this.EventBus.$emit('endIdentification', false);
          }
        );
    },
    animate(currentTime) {
      requestAnimationFrame(this.animate);
      this.contextRecordCircle.clearRect(
        0,
        0,
        this.canvasRecordCircle.width,
        this.canvasRecordCircle.height
      );
      var elapsed = currentTime - this.lastTimeRecordCircle;
      this.lastTimeRecordCircle = currentTime;
      var circle = this.circles.red;
      circle.visibleCountdown -= elapsed;
      if (circle.visibleCountdown > 0) {
        this.drawRecordCircle(circle);
      }
    },
    drawRecordCircle(circle) {
      this.contextRecordCircle.globalAlpha =
        circle.visibleCountdown / circle.visibleDuration;
      this.contextRecordCircle.beginPath();
      this.contextRecordCircle.arc(
        circle.x,
        circle.y,
        circle.radius,
        0,
        Math.PI * 2
      );
      this.contextRecordCircle.closePath();
      this.contextRecordCircle.fillStyle = circle.color;
      this.contextRecordCircle.fill();
      this.contextRecordCircle.globalAlpha = 1.0;
    },
    showRecordCircle(circle) {
      circle.visibleCountdown = circle.visibleDuration;
    },
    stopRecordCircle() {
      clearInterval(this.intervalRecordCircle);
    },
    // Calculate aspect ratio to draw rectangle over video
    calculateAspectRatio(videoWidth, videoHeight, isCedula, isDesktop, isHD) {
      var arWidth = videoWidth;
      var arHeight = videoHeight;
      var i = 2,
        result;
      result = this.getAspectRatio(
        arWidth,
        arHeight,
        videoWidth,
        videoHeight,
        isCedula,
        isHD,
        isDesktop
      );
      // if(!isDesktop) {
      //     if ((result.arHeight * 1.6) < videoHeight && (result.arWidth * 1.6) < videoWidth) {
      //         result.arHeight = result.arHeight * 1.6;
      //         result.arWidth = result.arWidth * 1.6;
      //     }
      // }
      return { arWidth: result.arWidth, arHeight: result.arHeight };
    },
    getAspectRatio(
      arWidth,
      arHeight,
      videoWidth,
      videoHeight,
      isCedula,
      isHD,
      isDesktop
    ) {
      var result;
      result = this.calculateAspectRatioDocuments(
        arWidth,
        arHeight,
        videoWidth,
        videoHeight,
        isDesktop
      );
      if (isCedula) {
        if (isHD)
          result = this.getMaxAspectRatioOverVideo(
            result.arWidth,
            result.arHeight,
            videoWidth,
            videoHeight,
            isCedula,
            1.1
          );
        else
          result = this.getMaxAspectRatioOverVideo(
            result.arWidth,
            result.arHeight,
            videoWidth,
            videoHeight,
            isCedula,
            1.4
          );
      } else {
        result = this.getMaxAspectRatioOverVideo(
          result.arWidth,
          result.arHeight,
          videoWidth,
          videoHeight,
          isCedula,
          1.6
        );
      }
      return { arWidth: result.arWidth, arHeight: result.arHeight };
    },
    calculateAspectRatioDocuments(
      arWidth,
      arHeight,
      videoWidth,
      videoHeight,
      isDesktop
    ) {
      var result;
      while (arHeight >= 640) {
        arHeight = arHeight / i;
        i++;
      }
      if (!isDesktop) {
        if (arHeight === videoHeight && arWidth === videoWidth) {
          // mobile
          arHeight = 150;
          arWidth = 240;
        } else {
          result = this.getRatio(arWidth, arHeight);
        }
      } else {
        result = this.getRatio(arWidth, arHeight);
      }
      if (typeof result === "undefined")
        return { arWidth: arWidth, arHeight: arHeight };
      else return { arWidth: result.arWidth, arHeight: result.arHeight };
    },
    getRatio(arWidth, arHeight) {
      if (arHeight >= 320 && arHeight < 640) {
        arHeight = 200;
        arWidth = 320;
      } else {
        arHeight = 200 * i;
        arWidth = 320 * i;
      }
      return { arWidth: arWidth, arHeight: arHeight };
    },
    getMaxAspectRatioOverVideo(
      arWidth,
      arHeight,
      videoWidth,
      videoHeight,
      isCedula,
      conversionValue
    ) {
      var width, height;
      if (isCedula) {
        if (
          arHeight * conversionValue < videoHeight &&
          arWidth * conversionValue < videoWidth
        ) {
          width = arHeight * conversionValue;
          height = arWidth * conversionValue;
          arWidth = width;
          arHeight = height;
        } else {
          width = arHeight;
          height = arWidth;
          arWidth = width;
          arHeight = height;
        }
      } else {
        if (
          arHeight * conversionValue < videoHeight &&
          arWidth * conversionValue < videoWidth
        ) {
          arHeight = arHeight * conversionValue;
          arWidth = arWidth * conversionValue;
        }
      }
      return { arWidth: arWidth, arHeight: arHeight };
    },
    // Center rectangle in the middle over video.
    calculateCanvasPosition(videoWidth, videoHeight, arWidth, arHeight) {
      var x = Math.round((videoWidth - arWidth) / 2);
      var y = Math.round((videoHeight - arHeight) / 2);
      return { x: x, y: y };
    },
    // Draw guide over video.
    insertCanvasOverVideo(
      canvas,
      context,
      videoWidth,
      videoHeight,
      arWidth,
      arHeight,
      x,
      y,
      color
    ) {
      context.font = "bold 20px verdana, sans-serif";
      context.fillStyle = "white";
      context.beginPath();
      context.lineWidth = 5;
      context.strokeStyle = color;
      context.moveTo(x, y);
      context.lineTo(x + 30, y);
      context.moveTo(x + 2.5, y);
      context.lineTo(x + 2.5, y + 30);
      context.moveTo(arWidth + x, y);
      context.lineTo(arWidth + x - 30, y);
      context.moveTo(arWidth + x - 2.5, y);
      context.lineTo(arWidth + x - 2.5, y + 30);
      context.moveTo(x, arHeight + y);
      context.lineTo(x + 30, arHeight + y);
      context.moveTo(x + 2.5, arHeight + y);
      context.lineTo(x + 2.5, arHeight + y - 30);
      context.moveTo(arWidth + x, arHeight + y);
      context.lineTo(arWidth + x - 30, arHeight + y);
      context.moveTo(arWidth + x - 2.5, arHeight + y);
      context.lineTo(arWidth + x - 2.5, arHeight + y - 30);
      context.fillStyle = "rgba(0, 0, 0, 0.3)";
      context.fillRect(0, 0, x, videoHeight);
      context.fillRect(x, 0, videoWidth, y);
      context.fillRect(arWidth + x, y, videoWidth, arHeight);
      context.fillRect(x, arHeight + y, videoWidth, arHeight + y);
      context.stroke();
    }
  }
};
</script>

<style>
#video {
  position: absolute;
  background: black;
  border: 1px solid black;
  box-shadow: 3px 5px 15px #1a1a1a;
}
.videoTransition {
  transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg); /* Safari and Chrome */
  -moz-transform: rotateY(180deg); /* Firefox */
}
.videoNoTransition {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  transition: none !important;
  border: 1px solid black;
  box-shadow: 3px 5px 15px #1a1a1a;
}
#canvas {
  visibility: hidden;
  position: absolute;
}
#canvasGuide {
  z-index: 1;
  position: absolute;
}
#canvasMessages {
  z-index: 2;
  position: absolute;
}
#canvasRectangle {
  z-index: 2;
  position: absolute;
}
#canvasCheckMark {
  z-index: 2;
  position: absolute;
  margin-top: 210px;
  left: -10px;
}
#canvasCheckMarkMobile {
  z-index: 2;
  position: absolute;
  margin-top: 210px;
  left: -10px;
}
.canvasCheckMarkMobilePortrait {
  z-index: 2;
  position: absolute;
  margin-top: 120px !important;
  left: -20px !important;
}
.canvasCheckMarkMobileLandscape {
  z-index: 2;
  position: absolute;
  margin-top: 80px !important;
  left: -20px !important;
}
#canvasRecordCircle {
  z-index: 2;
  position: absolute;
  margin-top: 450px;
  left: 610px;
}
.canvasRecordCircleMobilePortrait {
  z-index: 2;
  position: absolute;
  margin-top: 293px !important;
  left: 213px !important;
}
.canvasRecordCircleMobileLandscape {
  z-index: 2;
  position: absolute;
  margin-top: 213px !important;
  left: 293px !important;
}
#canvasLiveness {
  z-index: 2;
  position: absolute;
}
.pointCanvas {
  z-index: 2;
  position: absolute;
}
#canvasVideo {
  position: absolute;
  visibility: hidden;
}
.centerHorizontalAbsolute {
  top: 25%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.centerHorizontalAbsoluteOT {
  position: absolute;
  top: 25%;
  left: 0;
  right: 0;
  margin-left: auto !important;
  margin-right: auto !important;
}
</style>
